



















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore, { PessoaOperadora, ClassificacaoOperadora } from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegraDeCalculoIncluirOperadora extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalAddRegraCalculoOperadora() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoOperadora }
  set showModalAddRegraCalculoOperadora(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoOperadora', value }) }

  get porOperadoraOuPorClassificacao() { return this.getRegrasDeCalculoStore.porOperadoraOuPorClassificacao }
  set porOperadoraOuPorClassificacao(value: 'PorOperadora'| 'PorClassificacao') { this.getRegrasDeCalculoStore.setPorOperadoraOuPorClassificacao(value) }

  get pessoaOperadoraAIncluir() { return this.getRegrasDeCalculoStore.pessoaOperadoraAIncluir }
  set pessoaOperadoraAIncluir(value: PessoaOperadora) { this.getRegrasDeCalculoStore.setPessoaOperadoraAIncluir(value) }

  get classificacaoOperadoraAIncluir() { return this.getRegrasDeCalculoStore.classificacaoOperadoraAIncluir }
  set classificacaoOperadoraAIncluir(value: ClassificacaoOperadora) { this.getRegrasDeCalculoStore.setClassificacaoOperadoraAIncluir(value) }

  resetOperadoraAIncluir() {
    if (this.porOperadoraOuPorClassificacao === 'PorOperadora') this.getRegrasDeCalculoStore.clearClassificacaoOperadoraAIncluir()
    else this.getRegrasDeCalculoStore.clearPessoaOperadoraAIncluir()
  }

  get disabledIfNoValueSelected() {
    if (this.porOperadoraOuPorClassificacao === 'PorOperadora') return !this.pessoaOperadoraAIncluir.userId
    return !this.classificacaoOperadoraAIncluir.id
  }

  async addRegraCalculoOperadora() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.addRegraCalculoOperadora()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Operadora incluída com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModalAddRegraCalculoOperadora = false
  }

  @Watch('showModalAddRegraCalculoOperadora')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (value) {
      this.getRegrasDeCalculoStore.setPorOperadoraOuPorClassificacao('PorOperadora')
    }

    if (!value) {
      this.getRegrasDeCalculoStore.clearPessoaOperadoraAIncluir()
      this.getRegrasDeCalculoStore.clearClassificacaoOperadoraAIncluir()
      this.getRegrasDeCalculoStore.setPorOperadoraOuPorClassificacao('PorOperadora')
    }
  }
}
